import { css } from '@emotion/css';

export const iconButton = css`
  width: 2rem;
  height: 2rem;
  &:hover {
    background: none !important;
  }
`;
